<template>
  <div id="DmhBooking">
    <div v-if="loading" class="d-flex flex-column align-items-center justify-content-center">
      <b-spinner class="brand-primary"></b-spinner>
    </div>

    <div class="gp-select-container w-100 mb-5 pb-5 px-4" ref="gpSelectTop" v-else>
      <div
        class="d-flex flex-column align-items-center content-container booking-container-width w-100 animate__animated animate__fadeIn"
        v-if="selectedView === 'dateClinicianSelect'"
      >
        <div class="BookingSelection">
          <div v-if="noDates" class="no-appointments">
            <p class="no-appointments-text">
              No appointments are currently available. Please check back later.
            </p>
          </div>
          <div v-if="dates && !noDates">
            <h3 class="pb-4 brand-text dmh-start-title">
              Thank you! Let's book you in with a clinician
            </h3>
          </div>
          <div
            class="content-container d-flex flex-column justify-content-center align-items-center animate__animated animate__fadeIn"
          >
            <div class="date-selector-container" v-if="dates">
              <h4 class="dmh-section-title brand-text">Select a date</h4>
              <div class="slick-container">
                <slick ref="slickRef" class="slick-class" :options="slickOptions">
                  <div
                    v-for="(value, key) in dates"
                    :key="key"
                    class="d-flex align-items-center justify-content-center"
                  >
                    <b-button
                      :variant="
                        key === selectedDate ? 'option-selected' : 'option'
                      "
                      class="btn-date-time fixed-width"
                      @click="selectDate(key)"
                    >
                      {{ getFormatedDate(key, "DD MMM YYYY") }}
                    </b-button>
                  </div>
                </slick>
              </div>
            </div>
            <div class="dmh-clinicians-container" v-if="selectedDate">
              <h4 class="dmh-section-title brand-text w-100">
                Clinicians available
              </h4>
              <button
                class="dmh-clinician"
                :class="
                  i === selectedClinicianIndex
                    ? 'active btn-option-selected'
                    : 'btn-clinician-option'
                "
                v-for="(clinician, i) in dates[selectedDate]"
                :key="i"
                @click="selectClinicianIndex(i, clinician.clinicianId)"
              >
                <div
                  class="dmh-clinician-name"
                  :class="{ 'brand-text': i !== selectedClinicianIndex }"
                >
                  <span>{{ clinician.name }}</span>
                  <p class="clinician-info mt-1">{{ clinician.skills }}</p>
                </div>
<!--                <span-->
<!--                  v-if="clinician.recommended"-->
<!--                  class="recommended-lable brand-text"-->
<!--                  >Recommended!</span-->
<!--                >-->
              </button>
            </div>
            <div
              class="d-flex justify-content-center align-self-end pt-5 dmh-btn-container"
            >
              <b-button
                variant="cta-outline"
                size="lg"
                class="py-4 px-5"
                squared
                @click="previous(questionHistory)"
                >Previous</b-button
              >
              <b-button
                variant="cta"
                size="lg"
                squared
                :disabled="!selectedClinicianId"
                @click="selectView('timeslotSelect')"
                ><span v-if="!appointmentLoading">Continue</span
                ><b-spinner v-else></b-spinner
              ></b-button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="d-flex flex-column align-items-center content-container booking-container-width w-100 animate__animated animate__fadeIn"
        v-if="selectedView === 'timeslotSelect'"
      >
        <div class="BookingSelection">
          <div v-if="dates">
            <h3 class="brand-text dmh-start-title pb-3 mb-3">
              On {{ getFormatedDate(selectedDate, "DD MMM YYYY") }}, you're
              seeing
            </h3>
          </div>
          <div
            class="content-container d-flex flex-column justify-content-center align-items-center animate__animated animate__fadeIn"
          >
            <div class="dmh-clinicians-container">
              <div class="dmh-clinician active">
                <div class="dmh-clinician-name brand-text">
                  <span>{{
                    dates[selectedDate][selectedClinicianIndex].name
                  }}</span>
                  <p class="clinician-info mt-1">
                    {{ dates[selectedDate][selectedClinicianIndex].skills }}
                  </p>
                </div>
              </div>
              <button
                class="change-btn"
                @click="selectView('dateClinicianSelect')"
              >
                Change date or clinician
              </button>
            </div>
            <div class="w-100">
              <h4 class="select-time-title brand-text">Select a time</h4>
              <div class="dmh-timeslots-container">
                <div
                  class="dmh-timeslot-item"
                  v-for="(timeslot, i) in dates[selectedDate][
                    selectedClinicianIndex
                  ].timeslots"
                  :key="i"
                >
                  <b-button
                    :variant="
                      timeslot === selectedTimeslot
                        ? 'option-selected'
                        : 'option'
                    "
                    class="btn-date-time"
                    @click="selectTimeslot(timeslot)"
                  >
                    {{ timeslot }}
                  </b-button>
                </div>
              </div>
            </div>
            <div class="tcs-container">
              <p class="mb-0 text-center">
                <button @click="toggleTcAcceptence()" class="tc-button">
                  <i
                    class="clickable tc-checkbox mr-1"
                    :class="[
                      !tcsAccepted
                        ? 'fa-regular fa-square grey'
                        : 'fa fa-check-square filled'
                    ]"
                  ></i>
                </button>
                I have read and agree to the terms and conditions of this
                service listed
                <RouterLink :to="isServiceIncludedInPlan ? '/terms-and-conditions/included-in-plan' : '/terms-and-conditions/self-pay'" target="_blank" class="tcs-link brand-link pl-1">here</RouterLink>.
              </p>
            </div>
            <div
              class="d-flex justify-content-center align-self-end pt-5 dmh-btn-container"
            >
              <b-button
                variant="cta-outline"
                size="lg"
                class="py-4 px-4"
                :disabled="appointmentLoading"
                squared
                @click="selectView('dateClinicianSelect')"
                >Previous</b-button
              >
              <b-button
                variant="cta"
                size="lg"
                squared
                :disabled="
                  !selectedTimeslot || !tcsAccepted || appointmentLoading
                "
                @click="confirmBooking"
                ><span v-if="!appointmentLoading">{{
                  isServiceIncludedInPlan
                    ? "Confirm booking"
                    : "Confirm &amp; pay"
                }}</span
                ><b-spinner v-else></b-spinner
              ></b-button>
            </div>
          </div>
        </div>
      </div>
      <BookingConfirmed v-if="selectedView === 'bookingConfirm'" :is24HoursReminder="true" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "../../config/constants";
import slick from "vue-slick";
import ErrorModal from "../GP/ErrorModal.vue";
import moment from "moment";
import EventBus from "@/helpers/eventbus";
import { mapState } from "vuex";
import BookingConfirmed from "./BookingConfirmed.vue";

export default {
  name: "GpSelect",
  props: ["reset", "previous", "questionHistory", "bookingJourneyId"],
  components: {
    slick,
    BookingConfirmed
  },
  data() {
    return {
      loading: true,
      selectedView: "dateClinicianSelect",
      selectedDate: null,
      selectedFilter: "morning",
      selectedClinicianIndex: null,
      selectedClinicianId: null,
      selectedTimeslot: null,
      dates: false,
      clinicians: [],
      timeslots: [],
      timeslotsLoading: true,
      appointmentLoading: false,
      noDates: false,
      userDetails: { symptoms: "", photos: [] },
      tcsAccepted: false,
      slickOptions: {
        infinite: false,
        nextArrow: `<button type="button" class="slick-next"><i class="fa fa-caret-right" aria-hidden="true"></i></button>`,
        prevArrow: `<button type="button" class="slick-prev"><i class="fa fa-caret-left" aria-hidden="true"></i></button>`,
        slidesToScroll: 4,
        slidesToShow: 4,
        responsive: [
        {
            breakpoint: 700,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 520,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.getDates();
  },
  methods: {
    async confirmBooking() {
      if (this.isServiceIncludedInPlan) {
        await this.createAppointment();
      } else {
        await this.createAppointmentStripe();
      }
    },
    selectDate(date) {
      this.selectedDate = date;
      this.selectedClinicianIndex = null;
      this.selectedTimeslot = null;
      this.selectedClinicianId = null;
      // this.getTimeslots();
    },
    selectView(view) {
      if (view === "dateClinicianSelect") {
        this.selectedDate = null;
        this.selectedClinicianId = null;
      }
      this.selectedView = view;
    },
    toggleTcAcceptence() {
      this.tcsAccepted = !this.tcsAccepted;
    },
    selectTimeslot(time) {
      this.selectedTimeslot = time;
    },
    selectClinicianIndex(i, id) {
      this.selectedClinicianId = id;
      this.selectedTimeslot = null;
      this.selectedClinicianIndex = i;
    },
    buttonDisabled(date) {
      let today = moment().format("YYYY-MM-DD");
      return moment(date).isBefore(today);
    },
    async getDates() {
      const payload = {
        user_id: this.$store.getters.user_id,
        gender_preference: "No Preference",
        service_type: this.handoverPage?.service_type,
        booking_journey_id: this.bookingJourneyId,
      };
      let res = await axios.post(
        config.api_env + "/application/api/u/dmh/get-other-clinicians-dates",
        payload,
        config.options
      );
      if (res.data.success) {
        this.dates = res.data.dates;
        if (!this.dates || Object.keys(this.dates).length === 0) {
          this.noDates = true;
        }
      } else {
        this.noDates = true;
      }
      this.loading = false;
    },
    getTitleString(tags) {
      let title = "";
      tags.forEach(tag => {
        title = title + tag + ", ";
      });
      title = title.substring(0, title.length - 2);
      return title;
    },
    async createAppointment() {
      if (this.appointmentLoading) {
        return;
      }
      this.appointmentLoading = true;
      try {
        const payload = {
          user_id: this.$store.getters.user_id,
          clinician_id: this.selectedClinicianId,
          start_date: this.selectedDate,
          start_time: this.selectedTimeslot,
          service_type: this.handoverPage?.service_type,
          booking_journey_id: this.bookingJourneyId,
        };
        const res = await axios.post(
          config.api_env + "/application/api/u/dmh/book-appointment",
          payload,
          config.options
        );
        if (res.data.success) {
          if (
            res.data.apiStatus ===
            "Appointment has been already booked for the same slot. Please choose different clinician or slot."
          ) {
            this.openErrorModal(
              "Sorry, this appointment is no longer available",
              "Please choose another appointment"
            );
          } else {
            this.selectView("bookingConfirm");
            EventBus.$emit("hideProgressBar");
          }
        } else {
          this.openErrorModal(
            "Sorry, something went wrong",
            "Please try again"
          );
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.appointmentLoading = false;
      }
    },
    async createAppointmentStripe() {
      this.appointmentLoading = true;
      try {
				let s_type = this.handoverPage?.service_type ?? this.$route.query.service_id ?? 'no_service';
        const payload = {
          user_id: this.$store.getters.user_id,
          clinician_id: this.selectedClinicianId,
          start_date: this.selectedDate,
          start_time: this.selectedTimeslot,
          service_type: s_type,
          booking_journey_id: this.bookingJourneyId,
        };
        let res = await axios.post(
          config.api_env + "/application/api/u/dmh/get-payment-link",
          payload,
          config.options
        );
        if (res.data.success) {
          window.location.replace(res.data.link);
        } else {
          this.openErrorModal(
            "Sorry, something went wrong",
            "Please try again"
          );
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.appointmentLoading = false;
      }
    },
    openErrorModal(title, error, redirect, goBack) {
      const content = this.$createElement(ErrorModal, {
        props: { title, error, redirect, goBack }
      });
      const skin = this.$store.getters.skin;
      let opts = {
        hideHeader: true,
        hideFooter: true,
        modalClass: "coach_modal theme-" + skin,
        size: "md",
        buttonSize: "sm",
        centered: true,
        contentClass: "coach_modal",
        id: "error-modal"
      };
      return this.$bvModal.msgBoxOk(content, opts);
    }
  },
  computed: {
    ...mapState(["handoverPage", "servicePage"]),
    matchTechOptions() {
      return this.getMatchTechOptions();
    },
    isServiceIncludedInPlan() {
      return (
        this.servicePage?.plan_tag?.text.toLowerCase() ===
        "included with your plan"
      );
    }
  }
};
</script>
<style lang="less">
#DmhBooking {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 650px;
  margin: 0 auto;

  .tcs-link {
    font-family: "PlusJakartaSansBold";
    text-decoration: underline;
  }

  .tc-button {
    border: none;
    background-color: unset;
    padding: 0;
  }

  .tc-checkbox {
    font-size: 2rem;
    padding-left: 5px;

    &.grey {
      color: #aeb0bd;
    }

    &.filled {
      color: #1e1e22;
    }
  }

  .dmh-btn-container {
    gap: 24px;
  }

  .dmh-clinicians-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .dmh-clinician {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      text-align: left;
      width: 100%;
      padding: 20px;
      border-radius: 24px;
      margin-bottom: 20px;
      background-color: #fff;
      box-shadow: 0px 4px 24px 0px #00000012;

      .active {
        background-color: #fff;
      }

      .dmh-clinician-name {
        font-family: "PlusJakartaSansBold";
      }

      .recommended-lable {
        padding: 8px 16px;
        background-color: rgba(0, 230, 184, 0.4);
        border-radius: 40px;
        font-size: 1.2rem;
        font-family: "PlusJakartaSansBold";
      }

      .dmh-clinician-avatar {
        border-radius: 100px;

        img {
          height: 55px;
          margin-right: 25px;
          border-radius: 1000px;
          overflow: hidden;
        }
      }
    }
  }

  .fixed-width {
    max-width: 150px;
  }

  .sentence-case::first-letter {
    text-transform: uppercase;
  }

  .shadow {
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.2);
  }

  .booking-confirm-container {
    font-size: 1.8rem;
  }

  .booking-button {
    min-width: 200px !important;
  }

  .change-btn {
    color: #3c16f9;
    text-decoration: underline;
    font-family: "PlusJakartaSansBold";
    font-size: 1.4rem;
    background: unset;
    border: unset;
    align-self: flex-start;
    padding: 0;
    margin-bottom: 32px;
  }
  
  .slick-container {
    width: 100%;
    max-width: 616px;
  }

  .slick-slider {
    position: relative;
  }

  .slick-next, .slick-prev {
    position: absolute;
    z-index: 10;
    top: 50%;
    background-color: transparent;
    border: none;
    padding: 0 6px;
    transform: translateY(-50%);

    .fa {
      font-size: 3rem;
      color: #1E1E22;
    }
  }

  .slick-next {
    right: -30px;
  }

  .slick-prev {
    left: -30px;
  }

  .slick-slide {
    margin: 0 6px;
  }

  .slick-disabled {
    display: none !important;
  }

  .VueCarousel-navigation-button {
    font-size: 15px;
    top: 18px;
  }

  .container-width {
    max-width: 450px;
  }

  .booking-container-width {
    max-width: 800px;
  }

  .btn {
    min-width: 100px;
    margin-bottom: 10px;
  }

  .timeslot-button {
    color: #21272a;
  }

  .selected-date {
    color: white;

    &:hover {
      color: white;
    }
  }

  .preview-image {
    border-radius: 1000px;
    border: 6px solid;
    border-color: inherit;
    margin-bottom: 25px;
  }

  .no-appointments {
    font-size: 1.6rem;
  }

  .no-appointments-text {
    padding-top: 25px;
    font-size: 1.6rem;
  }

  .dmh-start-title {
    text-align: left;
    font-size: 2.2rem;
    letter-spacing: 0;
    padding-top: 0;
    font-family: "PlusJakartaSansBold";
  }

  .dmh-section-title {
    text-align: left;
    font-size: 1.8rem;
    letter-spacing: 0;
    font-family: "PlusJakartaSansBold";
    margin-bottom: 20px;
  }

  .select-time-title {
    text-align: left;
    font-size: 2.2rem;
    letter-spacing: 0;
    font-family: "PlusJakartaSansBold";
    margin-bottom: 16px;
  }

  .tc-link {
    color: #0079c8;
    text-decoration: underline;
  }

  .no-appointments {
    font-size: 1.6rem;
  }

  .no-appointments-text {
    padding-top: 25px;
    font-size: 1.6rem;
  }

  .fa-4x {
    color: green;
  }

  .tcs-container {
    align-self: flex-start;
  }

  .review-details {
    width: 100%;

    .text-prompt-container {
      max-width: 700px;
      font-size: 1.6rem;

      h3 {
        padding-top: 0;
        margin-top: 0;
        letter-spacing: normal;
        font-size: 1.8rem;
      }

      .details-container {
        width: 100%;
        background-color: white;
        border: 1px solid #dde1e6;

        .details-row {
          border-bottom: 1px solid #dde1e6;
          padding: 20px;
          word-wrap: break-word;
          text-align: left;

          .details-row-title {
            font-weight: 500;
            margin-bottom: 0;
            padding-bottom: 0;
          }

          .edit-button {
            align-self: start;
            cursor: pointer;
            font-weight: bold;
          }
        }
      }
    }

    .preview-image {
      max-width: 150px;
      min-width: 150px;
      min-height: 150px;
      max-height: 150px;
      object-fit: scale-down;
      border-radius: 16px;
      background-color: #eee;
    }
  }

  b {
    font-family: "PlusJakartaSansBold";
  }

  .clinician-info {
    font-size: 1.4rem;
    line-height: 2.2rem;
    color: #797b89;
    margin-bottom: 0;
  }

  .modal-content.coach_modal {
    border-radius: 16px;
  }

  .BookingSelection {
    width: 100%;
    max-width: 100%;
    font-size: 1.6rem;

    .button-group {
      border: 1px solid #0079c8;
      border-radius: 5px;
      background-color: white;
    }

    .date-selector-container {
      max-width: 650px;
      border-radius: 12px;
      padding: 20px 0;
      width: 100%;
      margin-bottom: 12px;
    }

    .dmh-timeslots-container {
      display: grid;
      gap: 16px 12px;
      grid-template-columns: auto auto auto;
      margin-bottom: 32px;
    }

    .btn-date-time {
      width: 100%;
      margin-bottom: 0;
    }

    .date-select-button {
      background-color: white;
      cursor: pointer;
      padding: 10px;
      font-size: 1.8rem !important;
      border: 1px solid white;
      color: #0079c8;
      border-radius: 8px;

      &:hover {
        background-color: #eee;
        border: 1px solid #eee;
      }

      .month-class {
        font-size: 1.4rem;
        color: #ccc;
      }
    }

    .preview-image {
      height: 80px;
      border-radius: 1000px;
      border: 3px solid;
      border-color: inherit;
    }

    .date-select-button:disabled,
    .date-select-button[disabled] {
      cursor: not-allowed;
      background-color: white;
      padding: 10px;
      font-size: 1.8rem !important;
      border: 1px solid white;
      border-radius: 8px;
      color: #ccc;

      &:hover {
        border: 1px solid white;
      }
    }

    .timeslot-button {
      color: #21272a;
      border: 1px solid #0079c8;
    }

    .selected-date {
      background-color: #0079c8;
      color: white;

      &:hover {
        background-color: #0079c8;
        color: white !important;
      }
    }

    .no-appointments {
      font-size: 1.6rem;
    }

    .no-appointments-text {
      padding-top: 25px;
      font-size: 1.6rem;
    }
  }

  @media only screen and (max-width: 380px) {
    .BookingSelection .dmh-timeslots-container {
      grid-template-columns: auto auto;
    }
  }

  @media only screen and (max-width: 576px) {
    .BookingSelection .dmh-clinicians-container .dmh-clinician {
      gap: 16px;
      flex-direction: column;
      align-items: flex-start;
    }

    .dmh-btn-container {
      gap: 16px;
    }
  }

  @media only screen and (max-width: 700px) {
    .slick-next {
      right: -20px;
    }

    .slick-prev {
      left: -20px;
    }
  }
}
</style>
